// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import CompanySubPage from '../../components/Company/CompanySubPage/CompanySubPage';
import ViewConstructionsReportComp from '../../components/Company/ViewConstructionsReport/ViewConstructionsReport';
// Type imports:
import { ICompanyReportViewModel } from '../../types/CompanyTypes';

const ViewConstructionsReport: React.FC<ICompanyReportViewModel> = ({
    id,
    eventId,
    isAuthenticated,
    isSubscriber
}) => {
    return (
        <Entrypoint>
            <CompanySubPage 
                id={id} 
                title='Vinnuvélar'
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
                subTitle='Vinnuvélar - Skýrsla'
                noAd
                component={
                    <ViewConstructionsReportComp
                        id={id ?? ''}
                        eventId={eventId ?? ''}
                    />
                }
                showRecentReports
            />
        </Entrypoint>
    );
}

export default ViewConstructionsReport;